import { ITimeTrackerProperties } from '@/legacy/apis/types/timeTrackerAPI';

export const displayInformation = (timeTrackerData: ITimeTrackerProperties) => {
  const { task, absenceCode } = timeTrackerData;
  if (task) {
    const {
      project: {
        name: projectName,
        customer: { name: customerName },
      },
      name: taskName,
    } = task;
    return {
      heading: customerName,
      title: projectName,
      subtitle: taskName,
    };
  }
  if (absenceCode) {
    const { name, description } = absenceCode;
    return {
      heading: 'Absence',
      title: name,
      subtitle: description,
    };
  }
  return {
    heading: '',
    title: '',
    subtitle: '',
  };
};
